/**
 * Visit completion data types and utilities
 */

/**
 * Raw visit completion data from API
 */
export interface VisitCompletionRawData {
  not_started?: number;
  emr_filled?: number;
  external_completion?: number;
  canceled_in_app?: number;
}

/**
 * Processed visit completion data with camelCase properties
 */
export interface VisitCompletionData {
  notStarted: number;
  emrFilled: number;
  externalCompletion: number;
  canceledInApp: number;
}

/**
 * Converts raw visit completion data from API to processed format
 */
export const toVisitCompletionData = (
  data: VisitCompletionRawData = {}
): VisitCompletionData => ({
  notStarted: data.not_started || 0,
  emrFilled: data.emr_filled || 0,
  externalCompletion: data.external_completion || 0,
  canceledInApp: data.canceled_in_app || 0,
});

/**
 * Calculate total visits
 */
export const getVisitCompletionTotal = (data: VisitCompletionData): number => {
  return (
    data.notStarted +
    data.emrFilled +
    data.externalCompletion +
    data.canceledInApp
  );
};

/**
 * Calculate pending visits (not started minus completed/canceled)
 */
export const getPendingVisits = (data: VisitCompletionData): number => {
  return Math.max(
    0,
    data.notStarted -
      (data.emrFilled + data.externalCompletion + data.canceledInApp)
  );
};

/**
 * Calculate Roger vs External percentage (EMR filled out of total completed)
 */
export const getRogerVsExternalPercentage = (
  data: VisitCompletionData
): string => {
  const totalCompleted = data.emrFilled + data.externalCompletion;
  return totalCompleted > 0
    ? ((data.emrFilled / totalCompleted) * 100).toFixed(1)
    : '0.0';
};
